module.exports = __webpack_public_path__ + "img/106_thumbnail.b810aa90.jpg";